import React, { useState } from 'react';
import { motion } from "framer-motion";

// For service Blog
const services = [
    {
        _id: "01.",
        title: "UI/UX Design",
        para: "Our UI/UX design service transforms user experiences into seamless, intuitive interactions.",
        subTitle: [
            "User Interface",
            "Figma",
            "User Experience design",
            "User research",
            "Design system",
            "Prototyping",
            "Mobile UI Design"
        ]
    },
    {
        _id: "02.",
        title: "Web Development",
        para: "We create scalable, robust mobile apps that perform well and offer a consistent user experience across devices.",
        subTitle: ["Javascript", "Next.js", "React.js", "Typescript", "Tailwind CSS", "ShadeCN", "HTML 5"]
    },
    {
        _id: "03.",
        title: "Digital Marketing",
        para: "Our expert team uses a data-driven approach, leveraging the latest techniques to boost your online presence.",
        subTitle: ["PPC (Pay-Per-Click) Advertising", "Content Marketing", "Analytics and Reporting", "SEO (Search Engine Optimization)"]
    },
    {
        _id: "04.",
        title: "Mobile App Development",
        para: "We create visually stunning and functional websites that not only attract visitors but also turn them into customers.",
        subTitle: ["Java", "Python", "React native", "C++", "C sharp", "C programming"]
    },
    {
        _id: "05.",
        title: "Graphic Design",
        para: "Our creative graphic designers produce engaging and impactful designs that capture your brand's essence.",
        subTitle: ["posters design", "social media post design", "logo design", "adobe express", "canva", "adobe illustrator"]
    },
];

const ServiceScroll = () => {
    return (
        <section id='ourservice' className="md:gap-5 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row relative gap-5 py-14 md:py-20">
            <div className="md:w-[60%] space-y-5">
                <div className="md:sticky top-36 lg:w-[80%] space-y-5">
                    <h2 className="text-3xl text-center font-bold text-gray-900 mb-4">
                        Our Services
                    </h2>
                    <div className="h-1 w-20 bg-yellow-400 mx-auto mb-6"></div>
                    <div className="space-y-3 lg:space-y-7">
                        <p className="text-lg leading-none font-semibold capitalize">
                            <span> discover Our Digital solutions</span>
                        </p>
                        <p className="text-sm md:text-base capitalize">
                            Explore our tailored services in technology, consulting, and staffing. At EXR Systems LLC, we deliver innovative solutions designed to meet your unique challenges and help your business thrive.
                        </p>
                    </div>
                </div>
            </div>

            <div className="mt-5 md:mt-0 w-full md:w-[40%] flex flex-col gap-5 items-center">
                {services.map((service, index) => (
                    <ServiceCard key={index} service={service} />
                ))}
            </div>
        </section>
    );
};

const ServiceCard = ({ service }) => {
    const [clicked, setClicked] = useState(null);

    const handleClick = (id) => {
        setClicked(id);
        setTimeout(() => setClicked(null), 500);
    };

    return (
        <motion.div
            className="p-5 w-full rounded-2xl border border-[#facc15]/30 sticky top-36 flex flex-col items-end gap-8 bg-white bg-gradient-to-t from-[#facc15]/50 to-transparent"
            initial={{ opacity: 0.5, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.5 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
        >
            <div className="flex flex-col gap-9">
                <div className="flex flex-col lg:flex-row gap-5">
                    <div>
                        <div className="w-10 h-10 bg-[#facc15] rounded-full flex justify-center items-center font-semibold text-lg">
                            <h1>{service._id}</h1>
                        </div>
                    </div>
                    <div className="space-y-2">
                        <h1 className="text-xl font-semibold line-clamp-1">{service.title}</h1>
                        <p className="text-xs md:text-sm capitalize">{service.para}</p>
                    </div>
                </div>

                <ul className="flex flex-wrap gap-2.5 text-sm">
                    {service.subTitle.map((item, index) => (
                        <li key={index} className="border border-white px-3 py-1 rounded-md inline-block">
                            {item}
                        </li>
                    ))}
                </ul>
            </div>
        </motion.div>
    );
};

export default ServiceScroll;